import { Theme } from '@mui/material';

export const CORNERS_RADIUS = '24px';
export const getContentPaddingY = (theme: Theme) => theme.spacing(2);
